// Takes custom column data and renders the statement heading.

import {
  IStatementColumns,
  langauge,
  StatementColumns,
} from "shared";

import { classNames } from "../../../../common/lib/classNames";

const moneyColumns: string[] = [
  StatementColumns.Amount,
  StatementColumns.NetAmount,
  StatementColumns.Payments,
  StatementColumns.Balance,
  StatementColumns.Tax,
  StatementColumns.PromptPaymentDiscountAmount,
];

// Prefer any per-column override label, then the language default, then the type (custom fields)
export function columnLabel(column: IStatementColumns[number]) {
  return column.label || langauge.settings.statement.statementColumnSettings[column.type]?.label || column.type;
}

export function isMoneyColumn(type: string) {
  return moneyColumns.includes(type);
}

const th = `whitespace-nowrap bg-paidniceGreen-50 px-1.5 py-2.5 text-[0.8125rem] font-semibold text-paidniceGreen-800 first:rounded-l-lg first:pl-2 last:rounded-r-lg last:pr-2`;

interface IStatementHeadingProps {
  columns: IStatementColumns;
  showPayColumn?: boolean;
}

export function StatementHeading({
  columns,
  showPayColumn,
}: IStatementHeadingProps) {
  return (
    <thead>
      <tr>
        <th
          scope={ `col` }
          className={ classNames(th, `w-5`) }
        />

        { columns.map((column, index) => (
          <th
            key={ `column-${index}-${column.type}` }
            scope={ `col` }
            className={ classNames(th, isMoneyColumn(column.type) ? `text-right` : `text-left`) }
          >
            { columnLabel(column) }
          </th>
        )) }

        { showPayColumn && (
          <th
            scope={ `col` }
            className={ classNames(th, `text-left`) }
          >
            { `Pay` }
          </th>
        ) }

        { /* Download and view links */ }
        <th
          scope={ `col` }
          className={ th }
        />
      </tr>
    </thead>
  );
}
